import { Button, Card, IconChevronRightCircle, IconDownload, IconInfo, Modal, OptionInterface, ProgressIndicator, Search, Select, Table, TableColumnWidth, TableColumns, TableData, TablePreferences } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ICategoryDto, IMaterialDto, IResourceDto } from "../../models/dto/trainingApi/IMaterialDto";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import TrainingLibraryService from "../../services/trainingApi/trainingLibrary.service";
import { Chip, Grid } from "@mui/material";
import ImageService from "../../services/generalApi/image.service";
import { format } from "date-fns";
import '../../assets/css/views/learning/trainingLibrary.css'
import { FileTypeEnum } from "../../models/enum/FileTypeEnum";
import { sanitizeUrl } from "../../utils/sanitizeText";

export default function TrainingLibrary() {
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    const [materialValue, setMaterialValue] = useState<any[]>([]);
    const [categoryValue, setCategoryValue] = useState<any[]>([]);
    const [optionsMaterials, setOptionsMaterials] = useState([]);
    const [optionsCategories, setOptionsCategories] = useState([]);
    const onChangeMaterials = (selectedOption: any) => setMaterialValue([selectedOption.value]);
    const onChangeCategories = (selectedOption: any) => setCategoryValue([selectedOption.value]);
    const onClearMaterials = () => setMaterialValue([]);
    const onClearCategories = () => setCategoryValue([]);
    const [tableData, setTableData] = useState<TableData[]>([]);
    const [hasClearAllFilters, setHasClearAllFilters] = useState(false);
    const [orderBy, setOrderBy] = useState('');
    const [orderType, setOrderType] = useState('');
    const [nameValue, setNameValue] = useState('');
    const handleNameFilter = (value: any) => setNameValue(value);
    const [formatValue, setFormatValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [open, setOpen] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [value, setValue] = useState<any>([]);

    const onChange = (selectedOption: any) => {
        setFormatValue(selectedOption.label);
        setValue([selectedOption.value]);
    }
    const onClear = () => {
        setValue([]);
        setFormatValue('');
    }

    const [options, setOptions] = useState<any[]>([]);

    useEffect(() => {
        getMaterial(languageId.value);
        getCategories(languageId.value);
    }, [languageId])

    useEffect(() => {
        if (materialValue.length > 0 && categoryValue.length > 0) {
            onClear();
            getResources(materialValue[0], categoryValue[0]);
        }
    }, [materialValue, categoryValue])

    const getMaterial = (languageId: number) => {
        TrainingLibraryService.getMaterials(languageId)
            .then((result) => {
                fillMaterialSelect(result);
            })
    }

    const getCategories = (languageId: number) => {
        TrainingLibraryService.getCategories(languageId)
            .then((result) => {
                fillCategorySelect(result);
            })
    }

    const getResources = (materialId: number, categoryId: number,) => {
        setLoading(true);
        TrainingLibraryService.getResources(materialId, categoryId, languageId.value)
            .then((result: IResourceDto[]) => {
                fillData(result);
                setLoading(false);
            })
    }

    const fillMaterialSelect = (data: IMaterialDto[]) => {
        const array: any = [];
        data.map(d => {
            array.push({ value: d.materialTypeID, label: d.materialType })
        });
        setOptionsMaterials(array);
    }

    const fillCategorySelect = (data: ICategoryDto[]) => {
        const array: any = [];
        data.map(d => {
            array.push({ value: d.categoryID, label: d.category })
        });
        setOptionsCategories(array);
    }

    // const handleActionRowConfig = (e: React.SyntheticEvent, option?: OptionInterface) => {
    //     if (option) {
    //         const resource = option.value.toString().split('|||');
    //         const format = Number(resource[0]);
    //         const url = resource[1];
    //         if (option.label === t("header.open")) {
    //             if (format === FileTypeEnum.indexed || format === FileTypeEnum.video)
    //                 window.open(url);
    //             else if (format === FileTypeEnum.pdf) {
    //                 getPdf(url);
    //             } else if (format === FileTypeEnum.image) {
    //                 getImage(url);
    //             }
    //         }
    //         else if (option.label === t("header.download")) {
    //             if (format === FileTypeEnum.pdf) {
    //                 downloadPdf(url, "pdf");
    //             } else if (format === FileTypeEnum.image) {
    //                 downloadImage(url, "image");
    //             }
    //         }
    //     }
    // }

    const getImage = (url: string) => {
        setShowLoading(true);
        setOpen(true)
        ImageService.getBlobImage(url)
            .then((r: any) => {
                const image = URL.createObjectURL(r);
                window.open(image);
                setShowLoading(false);
                setOpen(false)
            });
    }

    const getPdf = (url: string) => {
        setShowLoading(true);
        setOpen(true)
        ImageService.getBlobPdf(url)
            .then((r: any) => {
                setShowLoading(false);
                const pdf = URL.createObjectURL(r);
                window.open(pdf);
                setOpen(false)
            });
    }

    const downloadPdf = (url: string, filename: string) => {
        setShowLoading(true);
        setOpen(true)
        ImageService.getBlobPdf(url)
            .then((r: any) => {
                const pdf = URL.createObjectURL(r);
                const link = document.createElement('a');
                link.href = sanitizeUrl(pdf);
                link.download = filename;
                link.dispatchEvent(new MouseEvent('click'));
                setShowLoading(false);
                setOpen(false);
            });

    }

    const downloadImage = (url: string, filename: string) => {
        setShowLoading(true);
        setOpen(true)
        ImageService.getBlobImage(url)
            .then((r: any) => {
                const image = URL.createObjectURL(r);
                const link = document.createElement('a');
                link.href = sanitizeUrl(image);
                link.download = filename;
                link.dispatchEvent(new MouseEvent('click'));
                setShowLoading(false);
                setOpen(false)
            });

    }

    const getOptions = (resource: IResourceDto) => {
      const optionsArray = [];
      interface Option {
        value: number | string;
        label: string;
        icon: React.ReactNode;
    }
     
      const objOpen: Option = {
        value: `${resource.formatId}|||${resource.url}`,
        label: t("header.open"),
        icon: <IconChevronRightCircle />
      };

      const objDownload: Option = {
        value: `${resource.formatId}|||${resource.url}`, label: t("header.download"), icon: <IconDownload />
      };
        optionsArray.push(objOpen);
        if (resource.formatId === FileTypeEnum.image || resource.formatId === FileTypeEnum.pdf)
            optionsArray.push(objDownload);
        return optionsArray
  }

  const handleButtonClick = (options: OptionInterface) => {
    if (options) {
      const resource = options.value.toString().split('|||');
      const format = Number(resource[0]);
      const url = resource[1];
      if (options.label === t("header.open")) {
          if (format === FileTypeEnum.indexed || format === FileTypeEnum.video)
              window.open(url);
          else if (format === FileTypeEnum.pdf) {
              getPdf(url);
          } else if (format === FileTypeEnum.image) {
              getImage(url);
          }
      }
      else if (options.label === t("header.download")) {
          if (format === FileTypeEnum.pdf) {
              downloadPdf(url, "pdf");
          } else if (format === FileTypeEnum.image) {
              downloadImage(url, "image");
          }
      }
  }
  }

    const fillData = (data: IResourceDto[]) => {
        const pagedData: TableData[] = [];
        const formats: any[] = [];
        for (let i = 0; i < data.length; i++) {
          const resource: IResourceDto = data[i];
          const options = getOptions(resource);
          
            let tableData: TableData = {};
            tableData = {
                'materialName': resource.materialName,
                'newMaterial': resource.newMaterial ? <Chip label={t('header.newMaterial')} color="error" size="small" /> : <></>,
                'format': resource.format,
                'description': resource.description,
                'modifiedDate': format(new Date(resource.modifiedDate), 'dd/MM/yyyy'),
                'url': options.map(option => (
                  <Button
                    onClick={() => handleButtonClick(option)}
                    className="button-margin"
                    leadingIcon={option.icon}
                  >
                   {option.label}
                  </Button>
              )),
                // 'rowConfig': {
                //     action: <ContextualMenu
                //         onClick={handleActionRowConfig}
                //         options={getOptions(resource)}
                //         placement="leading"
                //     />,
                //     disabled: false,
                //     noWrap: false,
                //     selected: false,

                // }
            }
            if (!formats.some(f => f.value === resource.formatId))
                formats.push({ value: resource.formatId, label: resource.format });
            pagedData.push(tableData);
        }
        setOptions(formats);
        setTableData(pagedData);
    }

    const columns: TableColumns[] = [
        {
            id: 'materialName', label: t("header.material"), filter: (
                <div style={{ width: '80%' }}>
                    <Search
                        label={t("header.material")}
                        placeholder={t("header.material")}
                        id="table-filter-MaterialName"
                        value={nameValue}
                        onClear={() => setNameValue('')}
                        onChange={handleNameFilter}
                    />
                </div>
            ), sortable: true,
        },
        { id: 'newMaterial', label: '' },
        {
            id: 'format', label: t("header.format"), filter: (
                <div>
                    <Select
                        options={options}
                        id="select-usage"
                        label={t("header.format")}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={onChange}
                        onClear={onClear}
                        value={value}
                    />
                </div>
            ), sortable: true,
        },
        { id: 'description', label: t("header.description"), sortable: true, },
        { id: 'modifiedDate', label: t("header.modifiedDate"), sortable: true, },
        { id: 'url', label: "", sortable: true, }
    ];

    const columnsWidth: TableColumnWidth[] = [
        { columnId: 'newMaterial', width: '3%' },
        { columnId: 'materialName', width: '23%' },
        { columnId: 'format', width: '17%' },
        { columnId: 'description', width: '30%' },
        { columnId: 'modifiedDate', width: '12%' },
        { columnId: 'url', width: '15%' },
    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth,
        sortBy: { id: 'modifiedDate', type: 'ascending' },
    }

    const filteredData = filterSort(
        tableData,
        {
            materialName: nameValue,
            format: formatValue,

        },
        orderBy,
        orderType
    );

    const pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSelectPage = (event: any) => {
        const newTableData: any = Array.from(tableData, (v) => {
            const newValue: any = v;
            const index = pagedData.findIndex((p: any) => p.sid === newValue.sid);
            if (index > -1) {
                newValue.rowConfig.selected = event.target.checked;
            }
            return newValue;
        });
        setTableData(newTableData);
    };

    const handleSort = (_: any, { id, type }: any) => {
        setOrderBy(id);
        setOrderType(type);
    };

    const handleOnClearAllFilters = () => {
        setNameValue('');
        setFormatValue('');
    };

    function filterSort(array: any, filters: any, orderBy: any, orderType: any) {
        let arrayFiltered = array;
        // filter
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter =
                typeof filterValue === 'object' ? filterValue[0] : filterValue;
            if (filter) {
                arrayFiltered = arrayFiltered.filter((a: any) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();

                    return aUpper.indexOf(filterUpper) > -1;
                });
            }
        });

        // sort
        return arrayFiltered.sort((a: any, b: any) => {
            const value =
                orderType === 'descending'
                    ? descendingComparator(a, b, orderBy)
                    : -descendingComparator(a, b, orderBy);

            return value;
        });
    }

    const handleDeselectAllItems = (event: any) =>
        selectOrDeselectAllItems(event, false);

    const handlePageChange = (page: any) => {
        setCurrentPage(page);
        handleDeselectAllItems(null);
    };

    const handlePageSizeChange = (event: any, option: any) => {
        setPageSize(option.value);
    };
    const paginationProps = {
        currentPage,
        onPageChange: handlePageChange,
        onPageSizeChange: handlePageSizeChange,
        pageSize,
        pageSizeOptions: [{ value: 5 }, { value: 7 }, { value: 10 }],
        totalItems: filteredData.length,
    };

    const selectOrDeselectAllItems = (_: any, value: any) => {
        const newTableData = Array.from(tableData, (v) => {
            const newValue: any = v;
            newValue.rowConfig.selected = value;
            return newValue;
        });
        setTableData(newTableData);
    };

    useEffect(() => {
        return () => {
            selectOrDeselectAllItems(null, false);
        };
    }, []);

    function descendingComparator(a: any, b: any, orderBy: any) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();

        if (bSort < aSort) {
            return -1;
        }
        if (bSort > aSort) {
            return 1;
        }
        return 0;
    }

    useEffect(() => {
        if (materialValue || formatValue) {
            setHasClearAllFilters(true);
        } else {
            setHasClearAllFilters(false);
        }
    }, [materialValue, formatValue]);

    return (
        <div>
            <div style={{ padding: '20px' }}>
                <h4>{t("header.trainingLibrary")}</h4>
                <div style={{ padding: '20px' }}>
                    {
                        optionsMaterials?.length === 0
                            ?
                            <div className="container">
                                <div className="vertical-center">
                                    <ProgressIndicator
                                        appearance="circular"
                                        behavior="indeterminate"
                                    />
                                </div>
                            </div>
                            :
                            <div >
                                <Grid container spacing={2} style={{ marginBottom: '2%' }}>
                                    <Grid item xs={6} style={{ textAlign: 'left' }}>
                                        <Select
                                            options={optionsMaterials}
                                            id="select-usage"
                                            label={t('header.materials')}
                                            placement="bottom"
                                            helperTextVisibility="auto"
                                            onChange={onChangeMaterials}
                                            onClear={onClearMaterials}
                                            value={materialValue}
                                        />
                                    </Grid>
                                    <Grid item xs={6} style={{ textAlign: 'left' }}>
                                        <Select
                                            options={optionsCategories}
                                            id="select-usage"
                                            label={t('header.categories')}
                                            placement="bottom"
                                            helperTextVisibility="auto"
                                            onChange={onChangeCategories}
                                            onClear={onClearCategories}
                                            value={categoryValue}
                                        />
                                    </Grid>
                                </Grid>
                                {
                                    <Card
                                        appearance="outlined"
                                        content={
                                            <div style={{ padding: '20px' }}>
                                                <Table
                                                    preferences={tablePreferences}
                                                    showClearAllFilters={hasClearAllFilters}
                                                    onClearAllFilters={handleOnClearAllFilters}
                                                    showFilters
                                                    onSort={handleSort}
                                                    columns={columns}
                                                    data={pagedData}
                                                    loadingDataLength={10}
                                                    loading={loading}
                                                    behavior={{
                                                        type: 'singlePage',
                                                    }}
                                                    css={{
                                                        height: '63vh',
                                                    }}
                                                    pagination={paginationProps}
                                                    onDeselectAllItems={handleDeselectAllItems}
                                                    onSelectAllPageItems={handleSelectPage}
                                                    customNoItems={<div><div><IconInfo size={50} /></div>{t("header.noMaterialText")}</div>}
                                                    columnResize={true}
                                                />
                                            </div>
                                        }
                                    />
                                }
                            </div>
                    }
                    <Modal
                        align="start"
                        id="modal-id"
                        closeButton
                        show={open}
                        onClose={() => setOpen(false)}
                        footer={(
                            showLoading &&
                            <ProgressIndicator
                                appearance="linear"
                                behavior="indeterminate"
                            />
                        )}
                        title={t('header.loading')}
                    >
                        <div></div>
                    </Modal>
                </div>
            </div >
        </div >);
}